import { useState, useRef, useEffect } from "react";

const EditDropdown = ({ onEdit, onDelete }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();

  const toggleDropdown = () => setOpen(!open);

  const handleEdit = () => {
    onEdit();
    setOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="position-relative d-inline-block" ref={dropdownRef}>
      <i
        className="fa-solid fa-ellipsis-vertical "
        style={{ cursor: "pointer", fontSize: "1.2rem", padding: "4px" }}
        onClick={toggleDropdown}
      ></i>

      {open && (
        <div
          className="position-absolute bg-white shadow rounded border"
          style={{
            top: "calc(100% + 6px)",
            right: 0,
            minWidth: "150px",
            zIndex: 1000,
            padding: "4px 0",
          }}
        >
          <div
            className="dropdown-item d-flex align-items-center"
            style={{ cursor: "pointer", padding: "8px 12px", gap: "8px" }}
            onClick={handleEdit}
          >
            <i className="fa-solid fa-pen text-info"></i>
            <span>Edit</span>
          </div>
          <div
            className="dropdown-item d-flex align-items-center text-danger"
            style={{ cursor: "pointer", padding: "8px 12px", gap: "8px" }}
            onClick={handleDelete}
          >
            <i className="fa-solid fa-trash"></i>
            <span>Delete</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default EditDropdown;
